import { getNominationRoundYear } from './getNominationRoundYear';
import { tableRowsValuesScoring } from './tableRowsValuesScoring';
import { cmSeLabel } from './constants.js';

const extractCommitteeMembers = (committeeData) => [
  ...(committeeData.attributes?.committeeChair?.data
    ? [
        {
          id: committeeData.attributes.committeeChair.data.id,
          name: `${committeeData.attributes.committeeChair.data.attributes.username}`.split(
            ' (',
          )[0],
          isChair: true,
        },
      ]
    : []),
  ...(committeeData.attributes?.committeeMembers?.data || []).map((member) => ({
    id: member.id,
    name: `${member.attributes.username}`.split(' (')[0],
    isChair: false,
  })),
];

const getCommitteeName = (committeeData, sectionalCommitteesWithCmse) => {
  if (committeeData.id === 14 || committeeData.id === 15) {
    return cmSeLabel;
  }

  const committeeInfo = sectionalCommitteesWithCmse.find(
    (sc) => sc.id === committeeData.id,
  );
  return committeeInfo?.attributes?.name || 'Unknown Committee';
};

const processCommittee = (
  committeeData,
  sectionalCommitteesWithCmse,
  currentRoundScores,
  nominationArray,
  candidateArray,
  coiDeclarationArray,
  biasTrainingArray,
  currentRound,
  electionTypes,
) => {
  const committeeName = getCommitteeName(
    committeeData,
    sectionalCommitteesWithCmse,
  );
  const committeeMembers = extractCommitteeMembers(committeeData);

  if (committeeData.id === 14) {
    const correspondingData = tableRowsValuesScoring(
      committeeMembers,
      currentRoundScores,
      nominationArray,
      candidateArray,
      committeeName,
      committeeData.id,
      1, // Corresponding membership
      coiDeclarationArray,
      currentRound,
      biasTrainingArray,
      electionTypes,
    );

    const specialData = tableRowsValuesScoring(
      committeeMembers,
      currentRoundScores,
      nominationArray,
      candidateArray,
      committeeName,
      committeeData.id,
      3, // Special election
      coiDeclarationArray,
      currentRound,
      biasTrainingArray,
      electionTypes,
    );

    return [...correspondingData, ...specialData];
  }

  return tableRowsValuesScoring(
    committeeMembers,
    currentRoundScores,
    nominationArray,
    candidateArray,
    committeeName,
    committeeData.id,
    2, // Ordinary election
    coiDeclarationArray,
    currentRound,
    biasTrainingArray,
    electionTypes,
  );
};

export const getScoringTableData = (
  selectedCommittee,
  candidateScoresArray,
  committeeArray,
  sectionalCommitteesWithCmse,
  fellowsArray,
  nonAasRefereesArray,
  nominationArray,
  candidateArray,
  coiDeclarationArray,
  biasTrainingArray,
  electionTypes,
) => {
  const currentRound = getNominationRoundYear(new Date());

  const currentRoundScores = candidateScoresArray?.filter((score) => {
    const nominationRound =
      score.attributes?.nominationRound || score.nominationRound;
    return nominationRound === currentRound;
  });

  if (selectedCommittee) {
    const committeeData = committeeArray.find(
      (c) => c.id === parseInt(selectedCommittee),
    );

    if (!committeeData) {
      return { committees: [], allTableData: [] };
    }

    const tableData = processCommittee(
      committeeData,
      sectionalCommitteesWithCmse,
      currentRoundScores,
      nominationArray,
      candidateArray,
      coiDeclarationArray,
      biasTrainingArray,
      currentRound,
      electionTypes,
    );

    return { committees: [], allTableData: tableData };
  }

  const allTableData = [];

  committeeArray.forEach((committeeData) => {
    const committeeRows = processCommittee(
      committeeData,
      sectionalCommitteesWithCmse,
      currentRoundScores,
      nominationArray,
      candidateArray,
      coiDeclarationArray,
      biasTrainingArray,
      currentRound,
      electionTypes,
    );

    allTableData.push(...committeeRows);
  });

  return { committees: [], allTableData };
};
